export default () => ({
  entities: 'statistics',
  statistics: [],
  total: 0,
  currentMonth: null,
  scheduleYear: null,
  ishidden: false
})



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/company/gadget/components/summary-billing/resources/data.js